import { render, staticRenderFns } from "./bgTooltip.vue?vue&type=template&id=33ef56dc"
import script from "./bgTooltip.vue?vue&type=script&lang=ts"
export * from "./bgTooltip.vue?vue&type=script&lang=ts"
import style0 from "./bgTooltip.vue?vue&type=style&index=0&id=33ef56dc&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ef56dc')) {
      api.createRecord('33ef56dc', component.options)
    } else {
      api.reload('33ef56dc', component.options)
    }
    module.hot.accept("./bgTooltip.vue?vue&type=template&id=33ef56dc", function () {
      api.rerender('33ef56dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/event-table/custom-tooltips/bgTooltip.vue"
export default component.exports